export const leadStatuses = {
  SENT: 'SENT',
  NEGOTIATING: 'NEGOTIATING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  RECEIVED: 'RECEIVED',
};

// A negotiation runs alongside the standing offer rather than replacing it, so
// the seller keeps every action they had while it was merely sent.
export const openOfferStatuses = [leadStatuses.SENT, leadStatuses.NEGOTIATING];

export const leadItemStatuses = {
  USER_DECLINED: 'user_declined',
  ACCEPTED: 'accepted',
  RECEIVED: 'received',
};

export const declinedItemStatuses = [
  'user_declined',
  'condition_declined',
  'authenticity_concern',
  'system_declined',
];

export const itemOfferChoices = {
  DECLINE: 'decline',
  CONSIGNMENT: 'consignment',
  CASH: 'cash',
};

export const followUpStatuses = {
  ON_THEIR_WAY: 'ON THEIR WAY',
};
